var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon33(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 49,
    viewBox: "0 0 45 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.125 33.6667V15.3334C43.1242 14.5296 42.912 13.7402 42.5098 13.0444C42.1075 12.3485 41.5294 11.7707 40.8333 11.3688L24.7917 2.20212C24.0949 1.79985 23.3045 1.58807 22.5 1.58807C21.6955 1.58807 20.9051 1.79985 20.2083 2.20212L4.16667 11.3688C3.4706 11.7707 2.89245 12.3485 2.49022 13.0444C2.08799 13.7402 1.87582 14.5296 1.875 15.3334V33.6667C1.87582 34.4705 2.08799 35.2598 2.49022 35.9557C2.89245 36.6516 3.4706 37.2294 4.16667 37.6313L20.2083 46.798C20.9051 47.2002 21.6955 47.412 22.5 47.412C23.3045 47.412 24.0949 47.2002 24.7917 46.798L40.8333 37.6313C41.5294 37.2294 42.1075 36.6516 42.5098 35.9557C42.912 35.2598 43.1242 34.4705 43.125 33.6667Z",
    stroke: "#913BFF",
    strokeOpacity: 0.2,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8652 17.0961L22.1473 23.4423L33.4293 17.0961",
    stroke: "#9644FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 36.1346V25.5577",
    stroke: "#9644FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon33);
export default __webpack_public_path__ + "static/media/icon_33.2d3cd30065859bcf13a79a4a27639ea4.svg";
export { ForwardRef as ReactComponent };